export default __webpack_public_path__ + "static/media/game-examples.6b3d9c7b.md";